import en from "./i18n/en/translation.json";
import es from "./i18n/es/translation.json";
import pt from "./i18n/pt/translation.json";

export const TuvisMessagingI18N = { en, es, pt };
